module.exports = __webpack_public_path__ + "static/media/tutor-icon.5393da42.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/tutor-icon.svg
// module id = 1035
// module chunks = 0